export default {
      id: "trash-usage",
      viewBox: "0 0 23 25",
      url: "/" + "sprite.svg#trash",
      toString: function () {
        return this.url;
      }
    }